<snelstart-ui-details
  [config]="detailsConfig"
  [entityId]="id"
  title="{{id}}"
>
  <snelstart-ui-details-content>
    @switch (id) {
      @case ('Belastingplichtige') {
        <snelstart-venture-fiscaal-feature-algemeen></snelstart-venture-fiscaal-feature-algemeen>
      }
      @case ('Rondrekening') {
        <snelstart-venture-fiscaal-feature-overzicht></snelstart-venture-fiscaal-feature-overzicht>
      }
      @case ('Suppletie') {
        <snelstart-venture-fiscaal-feature-suppleties></snelstart-venture-fiscaal-feature-suppleties>
      }
      @case ('Administratie inlezen') {
        <snelstart-venture-fiscaal-feature-administratie-koppelen></snelstart-venture-fiscaal-feature-administratie-koppelen>
      }
      @case ('Fiscale eenheid') {
        <snelstart-venture-fiscaal-feature-fiscale-eenheid-vat></snelstart-venture-fiscaal-feature-fiscale-eenheid-vat>
      }
      @case ('Eerste kwartaal') {
        <snelstart-venture-fiscaal-feature-aangifte-vat></snelstart-venture-fiscaal-feature-aangifte-vat>
      }
      @case ('Tweede kwartaal') {
        <snelstart-venture-fiscaal-feature-aangifte-vat></snelstart-venture-fiscaal-feature-aangifte-vat>
      }
      @case ('Derde kwartaal') {
        <snelstart-venture-fiscaal-feature-aangifte-vat></snelstart-venture-fiscaal-feature-aangifte-vat>
      }
      @case ('Vierde kwartaal') {
        <snelstart-venture-fiscaal-feature-aangifte-vat></snelstart-venture-fiscaal-feature-aangifte-vat>
      }
      @case ('Jaaraangifte') {
        <snelstart-venture-fiscaal-feature-aangifte-vat></snelstart-venture-fiscaal-feature-aangifte-vat>
      }
      @case ('Januari') {
        <snelstart-venture-fiscaal-feature-aangifte-vat></snelstart-venture-fiscaal-feature-aangifte-vat>
      }
      @case ('Februari') {
        <snelstart-venture-fiscaal-feature-aangifte-vat></snelstart-venture-fiscaal-feature-aangifte-vat>
      }
      @case ('Maart') {
        <snelstart-venture-fiscaal-feature-aangifte-vat></snelstart-venture-fiscaal-feature-aangifte-vat>
      }
      @case ('April') {
        <snelstart-venture-fiscaal-feature-aangifte-vat></snelstart-venture-fiscaal-feature-aangifte-vat>
      }
      @case ('Mei') {
        <snelstart-venture-fiscaal-feature-aangifte-vat></snelstart-venture-fiscaal-feature-aangifte-vat>
      }
      @case ('Juni') {
        <snelstart-venture-fiscaal-feature-aangifte-vat></snelstart-venture-fiscaal-feature-aangifte-vat>
      }
      @case ('Juli') {
        <snelstart-venture-fiscaal-feature-aangifte-vat></snelstart-venture-fiscaal-feature-aangifte-vat>
      }
      @case ('Augustus') {
        <snelstart-venture-fiscaal-feature-aangifte-vat></snelstart-venture-fiscaal-feature-aangifte-vat>
      }
      @case ('September') {
        <snelstart-venture-fiscaal-feature-aangifte-vat></snelstart-venture-fiscaal-feature-aangifte-vat>
      }
      @case ('Oktober') {
        <snelstart-venture-fiscaal-feature-aangifte-vat></snelstart-venture-fiscaal-feature-aangifte-vat>
      }
      @case ('November') {
        <snelstart-venture-fiscaal-feature-aangifte-vat></snelstart-venture-fiscaal-feature-aangifte-vat>
      }
      @case ('December') {
        <snelstart-venture-fiscaal-feature-aangifte-vat></snelstart-venture-fiscaal-feature-aangifte-vat>
      }
      @case ('ICP opgave') {
        <snelstart-venture-fiscaal-feature-aangifte-icp></snelstart-venture-fiscaal-feature-aangifte-icp>
      }
    }
  </snelstart-ui-details-content>

  <snelstart-ui-details-buttons>
    <snelstart-ui-button type="primary"
                         [config]="saveButtonConfig">Opslaan
    </snelstart-ui-button>
  </snelstart-ui-details-buttons>
</snelstart-ui-details>
